import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from '../../services/modal/modal.service';
import { HelpersService } from '../../services/helpers.service';
import { ContractAvatarsService } from '../../modules/contracts/services/contract-avatar.service';
import { IMemberWithRole, MemberModel } from '../../models/user.model';

interface IMemberWithTooltip extends IMemberWithRole {
    tooltip?:string
} 
@Component({
    selector: 'app-avatar-panel',
    templateUrl: './avatar-panel.component.html',
    styleUrls: ['./avatar-panel.component.scss']
})
export class AvatarPanelComponent  {
    @Input() users: IMemberWithTooltip[] = [];
    private subs: Subscription = new Subscription();
    
    constructor(
        public modalService: ModalService,
        public helper: HelpersService,
        public translateService: TranslateService,
        private contractAvatarsService: ContractAvatarsService,
        private cds: ChangeDetectorRef,
    ) {
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    ngOnInit(): void {
        this.users.forEach(user=>{
    		let	role = this.translateService.instant('TASKS.TEXT.TASK_ROLES.' + user.role) + ': '
            user.tooltip =  role + this.helper.fullName(user.member)
        }
    )
        this.setSubscriptions()
    }
    setSubscriptions() {
        this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().subscribe(()=>this.cds.detectChanges()))
    }
}